export async function handleGTATracking(gta, gtaLabel, scripts) {
  // const shouldProcess = await checkTrackingConversion(gta, 'GTAtrackingConversion');
  // if (!shouldProcess) return;

  // GTA base scripts
  scripts.push({
    script: `<script defer src='https://www.googletagmanager.com/gtag/js?id=AW-${gta.trim()}'></script>`,
    name: "GTA",
    type: "GTA"
  });
  
  scripts.push({
    script: `<script>window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date()); gtag('config', 'AW-${gta.trim()}');</script>`,
    name: "GTA",
    type: "GTA"
  });

  // Conversion tracking
  scripts.push({
    script: `<script>gtag('event', 'conversion', {'send_to': 'AW-${gta.trim()}/${gtaLabel}'});</script>`,
    name: "GTA",
    type: "GTA"
  });
}